/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFBrandFinderDetails } from './CRSFBrandFinderDetails';
import {
    CRSFBrandFinderDetailsFromJSON,
    CRSFBrandFinderDetailsFromJSONTyped,
    CRSFBrandFinderDetailsToJSON,
} from './CRSFBrandFinderDetails';

/**
 * 
 * @export
 * @interface CRSFDomainExpansionItem
 */
export interface CRSFDomainExpansionItem {
    /**
     * 
     * @type {string}
     * @memberof CRSFDomainExpansionItem
     */
    brand_finder: string;
    /**
     * 
     * @type {CRSFBrandFinderDetails}
     * @memberof CRSFDomainExpansionItem
     */
    brand_finder_details?: CRSFBrandFinderDetails;
}

/**
 * Check if a given object implements the CRSFDomainExpansionItem interface.
 */
export function instanceOfCRSFDomainExpansionItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "brand_finder" in value;

    return isInstance;
}

export function CRSFDomainExpansionItemFromJSON(json: any): CRSFDomainExpansionItem {
    return CRSFDomainExpansionItemFromJSONTyped(json, false);
}

export function CRSFDomainExpansionItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFDomainExpansionItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brand_finder': json['brand_finder'],
        'brand_finder_details': !exists(json, 'brand_finder_details') ? undefined : CRSFBrandFinderDetailsFromJSON(json['brand_finder_details']),
    };
}

export function CRSFDomainExpansionItemToJSON(value?: CRSFDomainExpansionItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brand_finder': value.brand_finder,
        'brand_finder_details': CRSFBrandFinderDetailsToJSON(value.brand_finder_details),
    };
}

